/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type PdpSharedBlurbShipping_viewer$ref = any;
type PdpSharedBlurbSupportNumber_viewer$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type PdpRespSidebarBlurbs_viewer$ref: FragmentReference;
export type PdpRespSidebarBlurbs_viewer = {|
  +$fragmentRefs: PdpSharedBlurbShipping_viewer$ref & PdpSharedBlurbSupportNumber_viewer$ref,
  +$refType: PdpRespSidebarBlurbs_viewer$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "PdpRespSidebarBlurbs_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedBlurbShipping_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedBlurbSupportNumber_viewer",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '4fcd71bbf85c2f008a36812dee022a0e';
module.exports = node;
